// Display size of a one-pet-per-child companion by level (D-097, re-tiered by D-208). Form images
// are tight transparent crops, so drawn at one box size every form would look equally big. Stages,
// the tour and the home page scale the pet by this table instead, feet on the floor; collection
// views (companion cards, card walls, roster icons) keep one fixed size.
//
// D-208: the size is tiered by growth stage — a big visible jump at every evolution, only a hair
// of growth inside a form (the old continuous ramp moved just 2–4% at an evolution, unreadable).
// The four tiers are the same table the pet world (乐园) uses; see docs/pet-world-contract.md.
//
//   den / egg 40% · Lv1–9 49%→~52% · Lv10–19 66%→~70% · Lv20–29 85%→~90% · Lv30 100%
// Same species = same size in the classroom and on cards (fairness); only the pet world adds ±10%.
export const STAGE_BASE_SCALES = [.49, .66, .85, 1] as const;
const FORM_STARTS = [1, 10, 20, 30] as const;
export const DEN_SCALE = .4;
/** Extra growth per level inside a form, as a fraction of the form's base size (≤ ~5.4% over a form). */
const IN_FORM_STEP = .006;

/**
 * `shownStage` (D-214) is the form actually drawn (visualStage 1/10/20/30). While an evolution waits for a tap the level is
 * already past it; the size stays that of the drawn form (top of its range), so a pet never grows into a form it is not wearing.
 */
export function petGrowthScale(level: number, egg = false, shownStage?: number): number {
  if (shownStage !== undefined && shownStage >= 1) {
    const shown = FORM_STARTS.reduce((found, start, index) => (shownStage >= start ? index : found), 0);
    if (shown < 3) level = Math.min(level, FORM_STARTS[shown + 1] - 1);
  }
  if (egg || level < 1) return DEN_SCALE;
  const form = FORM_STARTS.reduce((found, start, index) => (level >= start ? index : found), 0);
  const base = STAGE_BASE_SCALES[form];
  if (form === 3) return base;
  const into = Math.min(level, FORM_STARTS[form + 1] - 1) - FORM_STARTS[form];
  return Math.round(base * (1 + into * IN_FORM_STEP) * 1000) / 1000;
}
